package com.fireavert.utilities

actual object KotlinStringFormatter {
    actual fun format(input: Float, digits: Int): String =
        input.asDynamic().toFixed(digits) as String
    actual fun format(input: Double, digits: Int): String =
        input.asDynamic().toFixed(digits) as String
}